var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgXtvcbtc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F7931A",
    d: "M0 0h18v18H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.836 7.94c.166-1.123-.684-1.721-1.855-2.128l.38-1.513-.926-.23-.369 1.476-.738-.177.375-1.486-.925-.23-.38 1.518-.588-.139v-.005l-1.278-.32-.246.988s.684.16.674.166c.374.096.438.342.427.535L6.96 8.128l.096.032-.102-.022-.604 2.423c-.043.112-.16.283-.423.214.011.016-.668-.16-.668-.16l-.46 1.053 1.203.3.658.17-.385 1.535.925.23.374-1.519.744.193-.38 1.513.925.23.38-1.535c1.577.3 2.765.182 3.262-1.246.401-1.15-.021-1.807-.85-2.246.604-.133 1.059-.534 1.176-1.353h.005zm-2.112 2.963c-.283 1.15-2.219.524-2.845.374l.508-2.037c.626.16 2.637.465 2.337 1.658v.005zm.284-2.979c-.257 1.043-1.872.514-2.39.385l.46-1.844c.523.128 2.202.374 1.93 1.46z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXtvcbtc);
export default __webpack_public_path__ + "static/media/XTVCBTC.768cc16eb7b1aef81d7ac05fd993af58.svg";
export { ForwardRef as ReactComponent };